module.exports = __webpack_public_path__ + "media/scale-weight.e8187fc9.svg";